import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { app } from "../../../Frame/App";
import { LanguageString } from "../../../Model/LanguageString";
import { WidgetController } from "../WidgetController";
import { PopupStatisticComponent } from "../Popups/PopupStatisticComponent";
import { WidgetStatisticComponent } from "../Components/WidgetStatisticComponent";

export enum TemplateStatus {
    DueSoon, Delayed, Closed, InProgress, All
}

export class WidgetStatisticProps {
    public title: LanguageString;
    public templateIds: number[];
    public categoryId: number;
    public showTotal: boolean;
    public showOpen: boolean;
    public statusDelayed: boolean ;
    public statusClosed: boolean;
    public statusDueSoon: boolean;
    public statusOnHold: boolean;
    public statusInPlan: boolean ;
    public statusAll: boolean;

    constructor() {
        this.templateIds = [];
        this.title = new LanguageString();
        this.showTotal = true;
        this.showOpen = true;
        this.statusAll = true;
    }
}

export class WidgetStatistic extends WidgetBase {
    props: WidgetStatisticProps;

    constructor(controller: WidgetController) {
        super(controller,2, 2);
        this.props = new WidgetStatisticProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.Statistic;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (!this.props.templateIds) {
                this.props.templateIds = [];
            }

            if (this.props.title == null)
                this.props.title = new LanguageString();
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetStatisticComponent({
            widget: this
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupStatisticComponent({ widget: this });
        document.body.appendChild(popup.render());
        popup.updateCheckbox();
    }

}